module.exports = __webpack_public_path__ + "img/EU-NEXT-GEN.d0731270.jpg";